import React from 'react';
// Importa el hook personalizado useScrollPosition desde la carpeta hooks
import { useScrollPosition } from '../../hooks';

/**
 * Componente DepthLayers
 * Crea un efecto de profundidad con múltiples capas moviéndose a diferentes velocidades
 * 
 * @param {Array} layers - Array de objetos con propiedades: speed, zIndex, content
 */
export const DepthLayers = ({ layers = [] }) => {
  // Obtiene la posición vertical del scroll usando el hook personalizado
  const { scrollY } = useScrollPosition();
  
  return (
    // Contenedor principal con posición relativa y pantalla completa
    <div className="relative w-full h-screen overflow-hidden">
      {/* Itera sobre cada capa recibida por props */}
      {layers.map((layer, index) => (
        <div
          key={index} // Clave única para cada elemento de la lista
          className="absolute inset-0" // Posiciona cada capa absolutamente sobre el contenedor
          style={{
            // Aplica una transformación vertical basada en el scroll y la velocidad de la capa
            transform: `translateY(${scrollY * (layer.speed || 0.5)}px)`,
            // Define el z-index para controlar la profundidad de la capa
            zIndex: layer.zIndex || index,
          }}
        >
          {/* Renderiza el contenido de la capa */}
          {layer.content}
        </div>
      ))}
    </div>
  );
};